export { StickyCard } from "./sticky-card";
